import { Accordion, Footer} from '../container';
import PageHero from "../components/PageHero/PageHero";
import aboutBg from "../assets/bgimage.jpg";
export default function AccordionPage() {
  return <>
  <PageHero title="FAQs" bgImage={aboutBg} />
  <Accordion />
  <Footer/></>;
}
